const Domain = "https://kvkkapi.web2c.net";
export default Domain;